var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from '@max/max';
import { request as maxRequest } from '@max/meituan-uni-network';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { getRiskParams } from '@nibfe/mkt-risk-api';
import { getAppVersion, getSystemType, SystemType, isWeixinMiniProgramOrWeixinWebview, isMiniProgramOrWebview } from '@nibfe/mkt-env-api';
import { getSource, isInHarmony } from '@/utils/common';
const isWeb = true;
import { getLocation } from '@nibfe/mkt-lbs-api';
import { getSelectedCityInfo } from '@max/meituan-uni-city';
import { LOCATION_SCENE_TOKEN, USER_INFO_VALID_CODE, USER_INFO_EXPIRED } from '@/constants';
import { navigateTo } from "@max/meituan-uni-navigate";
const API_MAP = {
    // PROD: 'https://chenzhuo24-glvdc-sl-api.hotel.test.meituan.com', // todo 测试泳道，上线前改回
    PROD: 'https://ihotel.meituan.com',
    TEST: 'http://api.hotel.test.meituan.com',
    SL: 'https://liuxu79-bneil-sl-api.hotel.test.meituan.com',
    PAPI_MOCK: 'https://papi.sankuai.com/api/req/c80c3278-f278-493d-b8c1-4f8048562846'
};
export var API_PATH;
(function (API_PATH) {
    API_PATH["ACTIVITY_INFO"] = "/api/altas/marketing/activity/query/info";
    API_PATH["DRAW_PRIZE"] = "/api/altas/marketing/activity/draw/prize";
    API_PATH["QUERY_INTENTION"] = "/api/altas/marketing/query/userTag";
    API_PATH["COUPON_USAGE_LIST"] = "/api/altas/marketing/coupon/usage/list";
    API_PATH["QUERY_APPOINTMENT"] = "/api/altas/marketing/user/query/appointment";
    API_PATH["CREATE_APPOINTMENT"] = "/api/altas/marketing/user/appointment";
    API_PATH["COMPLETE_TASK"] = "/api/altas/marketing/task/complete";
    API_PATH["JOIN_ACTIVITY"] = "/api/altas/marketing/activity/join/activity";
})(API_PATH || (API_PATH = {}));
/**
 * 请求状态枚举
 */
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus[RequestStatus["IDLE"] = 0] = "IDLE";
    RequestStatus[RequestStatus["LOADING"] = 1] = "LOADING";
    RequestStatus[RequestStatus["SUCCESS"] = 2] = "SUCCESS";
    RequestStatus[RequestStatus["ERROR"] = 3] = "ERROR";
})(RequestStatus || (RequestStatus = {}));
export const handleParams = (params = {}) => {
    return Object.keys(params !== null && params !== void 0 ? params : {}).map((key, index) => {
        const value = params[key];
        if (!params[key]) {
            return;
        }
        if (index === 0) {
            return value ? `?${key}=${value}` : '';
        }
        else {
            return value ? `&${key}=${value}` : '';
        }
    }).join('');
};
/**
 * useRequest Hook - 用于封装API请求
 * @param path API路径
 * @param options 配置选项
 * @returns 包含请求函数和状态的对象
 */
export function useRequest(path, options) {
    const { showLoading = false, loadingText = '加载中...', raw = false, method = 'POST' } = options || {};
    const ctx = useMonitorEngineContext();
    const [requestStatus, setRequestStatus] = useState(RequestStatus.IDLE);
    const [error, setError] = useState(null);
    /**
     * 获取风险参数
     */
    const getRiskRequest = (uuid) => __awaiter(this, void 0, void 0, function* () {
        const systemType = getSystemType();
        const isIOS = systemType === SystemType.ios;
        const isAndroid = systemType === SystemType.android;
        const location = yield getLocateCityInfo();
        let riskRequest = {};
        try {
            riskRequest = yield getRiskParams(/** 风险标识-酒店 */ 2);
        }
        catch (e) {
            // empty
        }
        const version = getAppVersion();
        return Object.assign(Object.assign(Object.assign({}, riskRequest), { utmMedium: isIOS ? 'iphone' : isAndroid ? 'android' : isInHarmony ? 'HarmonyOS' : '', utmCampaign: 'texactivity', utmContent: uuid, utmTerm: version, utmSource: 'meituaninternaltest', versionName: version, sourceType: 'hotel' }), location);
    });
    const getLocateCityInfo = () => __awaiter(this, void 0, void 0, function* () {
        const locationResult = {
            latitude: '0.0',
            longitude: '0.0',
            locateCityId: 1
        };
        try {
            const [location, cityInfo] = yield Promise.all([getLocation({
                    sceneToken: LOCATION_SCENE_TOKEN
                }), getSelectedCityInfo()]);
            locationResult.latitude = `${location.lat || '0.0'}` || '0.0';
            locationResult.longitude = `${location.lng || '0.0'}` || '0.0';
            locationResult.locateCityId = cityInfo.id || 1;
        }
        catch (e) { }
        return locationResult;
    });
    /**
     * 执行请求
     * @param params 请求参数
     * @returns 响应数据
     */
    const request = (params) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        try {
            const { uuid, platform, userId, token, cityInfo = {} } = ((_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams) || {};
            const isInWxWebview = isWeixinMiniProgramOrWeixinWebview() && !isMiniProgramOrWebview();
            function tryLogin() {
                var _a;
                if (isWeb && isInWxWebview) {
                    const backUrl = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) || '';
                    navigateTo({
                        url: `https://passport.meituan.com/useraccount/ilogin?backurl=${encodeURIComponent(backUrl)}&risk_partner=0&risk_app=-1&risk_platform=3`
                    });
                }
                else {
                    // ctx._userAPI.login()
                }
            }
            // 检查用户信息
            if (!userId || !token) {
                const error = new Error('用户未登录');
                setError(error);
                setRequestStatus(RequestStatus.ERROR);
                tryLogin();
                return null;
            }
            setRequestStatus(RequestStatus.LOADING);
            setError(null);
            // @ts-expect-error
            if (isWeb && window.H5guard) {
                // @ts-expect-error
                window.H5guard.init({});
            }
            let isPtest = false; // TODO: importatnt
            if (isWeb && Boolean((_c = (_b = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _b === void 0 ? void 0 : _b.queryParams) === null || _c === void 0 ? void 0 : _c.isPtest)) {
                isPtest = true;
            }
            const riskRequest = yield getRiskRequest(uuid);
            let url = `${API_MAP.PROD}${path}`; // TODO:important
            // let url = `${API_MAP.PAPI_MOCK}${path}`;
            // let url = `${API_MAP.TEST}${path}`;
            if (isPtest) {
                url = `${url}?isPtest=true`;
            }
            const locateCityId = riskRequest.locateCityId;
            const cityId = cityInfo.cityId;
            // 任务完成接口做特殊化处理
            let taskType;
            if (params.taskType) {
                taskType = params.taskType;
                delete params.taskType;
                // @ts-expect-error
                riskRequest.taskType = taskType;
            }
            const response = yield new Promise((resolve, reject) => {
                maxRequest({
                    url,
                    method,
                    data: Object.assign(Object.assign({}, params), { userId: String(userId), 
                        // userId,
                        // token,
                        platform: platform === 'dp' ? 2 : 1, 
                        // 目前不支持点评
                        riskRequest, source: getSource(), version: riskRequest.version, pageSource: '', 
                        // 页面来源，暂时不用传
                        uuid,
                        locateCityId,
                        cityId, latitude: riskRequest.latitude, longitude: riskRequest.longitude }),
                    header: {
                        'content-type': 'application/json',
                        token
                    },
                    _meituan: {
                        requestType: 'MRNUtils',
                        mrnChannel: 'hotel',
                        params: isPtest ? {
                            isPtest: true
                        } : {}
                    },
                    success(res) {
                        var _a, _b, _c, _d, _e, _f, _g, _h;
                        (_b = (_a = ctx._raptorReport) === null || _a === void 0 ? void 0 : _a.monitorReportNetworkSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
                            apiPath: path
                        });
                        if (raw) {
                            resolve(res);
                            return;
                        }
                        if (((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.code) === 0 || ((_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.status) === 0) {
                            resolve(((_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.data) || (res === null || res === void 0 ? void 0 : res.data));
                        }
                        else if ([USER_INFO_VALID_CODE, USER_INFO_EXPIRED].includes((_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.code) || [USER_INFO_VALID_CODE, USER_INFO_EXPIRED].includes((_g = res === null || res === void 0 ? void 0 : res.data) === null || _g === void 0 ? void 0 : _g.status)) {
                            tryLogin();
                        }
                        else {
                            const error = new Error(((_h = res === null || res === void 0 ? void 0 : res.data) === null || _h === void 0 ? void 0 : _h.message) || '请求失败');
                            reject(error);
                        }
                    },
                    fail(error) {
                        var _a, _b;
                        (_b = (_a = ctx._raptorReport) === null || _a === void 0 ? void 0 : _a.monitorReportNetworkFailed) === null || _b === void 0 ? void 0 : _b.call(_a, {
                            apiPath: path
                        });
                        reject(error);
                    }
                });
            });
            setRequestStatus(RequestStatus.SUCCESS);
            return response;
        }
        catch (err) {
            const error = err instanceof Error ? err : new Error('Unknown error');
            // console.log('请求异常>>:', error);
            setError(error);
            setRequestStatus(RequestStatus.ERROR);
            // 记录错误日志
            (_e = (_d = ctx._raptorReport) === null || _d === void 0 ? void 0 : _d.monitorReportLog) === null || _e === void 0 ? void 0 : _e.call(_d, '网络请求异常', error, {
                level: 'error',
                category: 'networkError',
                tags: {
                    apiPath: path,
                    errorMessage: error.message
                }
            });
            return null;
        }
    });
    return {
        requestStatus,
        error,
        request
    };
}
